import { Component, EventEmitter, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { ProductCategoryNewCategoryDialogComponent } from '../product-category-new-category-dialog/product-category-new-category-dialog.component';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-product-category-header',
  templateUrl: './product-category-header.component.html',
  styleUrls: ['./product-category-header.component.scss'],
})
export class ProductCategoryHeaderComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private dialog_service: DialogService,
    private error_service: ErrorService,
    private navigation_service: NavigationService,
  ) {}

  onAddClick() {
    this.dialog_service
      .openDialog(ProductCategoryNewCategoryDialogComponent)
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onBackClick(): void {
    this.navigation_service.toSettings();
  }
}
